import React from "react";
import { useDataContext } from "context/DataContext";
import { FlexBox } from "styles/global";
import {
  BigCard,
  CardHeaderClean,
  ChipsCardClean,
  ChipsCardEspecialidade,
  HospitalChip,
  PLineHeigth4,
} from "../DataFetcher/styled-datafetcher";
import { IoIosPeople } from "react-icons/io";
import Tooltip from "@mui/material/Tooltip";
import { LocalHospitalOutlined } from "@mui/icons-material";
import strings from "constants/strings";
// import { FaClock } from "react-icons/fa";
import { BoxEspecialidade } from "./styled";

interface HospitalCardProps {
  hospitalId: string;
  hospitalData: any;
  cardWidth: string;
}

const NewBigCardHospital: React.FC<HospitalCardProps> = ({
  hospitalId,
  hospitalData,
  cardWidth,
}) => {
  const { especialidadesColorMap, tempoMedio24horas, tempoMedio7dias } =
    useDataContext();

  const slotProps = (color: string, fontColor: string) => ({
    popper: {
      modifiers: [
        {
          name: "offset",
          options: {
            offset: [0, -8],
          },
        },
      ],
    },
    tooltip: {
      style: {
        backgroundColor: color,
        color: fontColor,
      },
    },
    arrow: {
      style: {
        color: color,
      },
    },
  });

  const riscoColorMap = [
    { color: "#DE1E1F", risco: "vermelho", fontColor: "#fff" },
    { color: "#E96F19", risco: "laranja", fontColor: "#fff" },
    { color: "#ffce24", risco: "amarelo", fontColor: "#000" },
    { color: "#077d04", risco: "verde", fontColor: "#fff" },
    { color: "#007bff", risco: "azul", fontColor: "#fff" },
  ];

  function normalize(str: string) {
    return str
      .normalize("NFD") // separa acentos
      .replace(/[\u0300-\u036f]/g, "") // remove acentos
      .toLowerCase();
  }

  const hospital24h =
    tempoMedio24horas[hospitalId as keyof typeof tempoMedio24horas];

  const hospital7d =
    tempoMedio7dias[hospitalId as keyof typeof tempoMedio7dias];

  return (
    <BigCard hospital={hospitalId}>
      <CardHeaderClean hospital={hospitalId}>
        <h3>
          <FlexBox gap="5px" align="center">
            <LocalHospitalOutlined
              sx={{
                fontSize: 24,
                position: "relative",
                top: -1,
              }}
            />
            {hospitalId}
          </FlexBox>
        </h3>
      </CardHeaderClean>
      <div style={{ width: cardWidth }}>
        {/* DADOS HOSPITAL */}
        <HospitalChip hospital={hospitalId}>
          <FlexBox justify="center">
            <div
              style={{
                // width: "66%",
                width: "100%",
                margin: "0 1rem 1rem",
              }}
            >
              <PLineHeigth4 hospital={hospitalId}>agora</PLineHeigth4>
              <FlexBox
                justify="space-around"
                align="center"
                style={{
                  // backgroundColor: "#F5F5F5",
                  backgroundColor: "#8791c350",
                  // border: "1px solid #DAA520",
                  borderRadius: "10px",
                  padding: "10px 1rem",
                }}
              >
                <ChipsCardClean>
                  <p>Total de Pacientes {strings.hospital.total_aguardando}</p>
                  <FlexBox gap="10px">
                    <span>{hospitalData.PacientesAguardando}</span>
                    <IoIosPeople size="35px" />
                  </FlexBox>
                </ChipsCardClean>
                <div
                  style={{
                    // width: "50%",
                    // borderLeft: "1px solid rgb(218, 165, 32)",
                    paddingLeft: "1rem",
                    marginLeft: "1rem",
                  }}
                >
                  <ChipsCardClean>
                    <FlexBox gap="10px">
                      <p>{strings.hospital.classificacao_risco}</p>
                    </FlexBox>

                    <FlexBox gap="1rem">
                      {riscoColorMap.map(({ color, risco, fontColor }) => (
                        <Tooltip
                          key={risco}
                          title={risco}
                          arrow
                          slotProps={slotProps(color, fontColor)}
                        >
                          <FlexBox
                            // direction="column"
                            align="center"
                            justify="center"
                            gap="5px"
                          >
                            <IoIosPeople size="25px" color={color} />
                            <ChipsCardClean>
                              <span className="smallNum">
                                {risco === "vermelho"
                                  ? 0
                                  : hospitalData[
                                      `total_risco_${risco}` as keyof typeof hospitalData
                                    ] ?? 0}
                              </span>
                            </ChipsCardClean>
                          </FlexBox>
                        </Tooltip>
                      ))}
                    </FlexBox>
                  </ChipsCardClean>
                </div>
              </FlexBox>
            </div>

            {/* <div
              style={{
                width: "50%",
                // margin: "1rem 1rem 1rem 0",
                margin: "0 1rem 1rem 0",
              }}
            >
              <PLineHeigth4 hospital={hospitalId}>últimas 24h</PLineHeigth4>
              <FlexBox
                justify="space-around"
                gap="4rem"
                style={{
                  backgroundColor: "#F5F5F5",
                  // border: "1px solid #A9A9A9",
                  borderRadius: "10px",
                  padding: "10px 1rem",
                  height: 68,
                }}
              >
                <ChipsCardClean>
                  <p>{strings.gaes}</p>
                  <FlexBox gap="10px">
                    <span style={{ fontWeight: "normal" }}>
                      {hospitalData.GAESAbertas}
                    </span>
                    <IoIosPeople size="30px" />
                  </FlexBox>
                </ChipsCardClean>
                <ChipsCardClean style={{ marginRight: 70 }}>
                  <p>{strings.desistentes}</p>
                  <FlexBox gap="10px">
                    <span style={{ fontWeight: "normal" }}>
                      {hospitalData.Desistentes}
                    </span>
                    <IoIosPeople size="30px" />
                  </FlexBox>
                </ChipsCardClean>
              </FlexBox>
            </div> */}
          </FlexBox>
        </HospitalChip>

        {/* DADOS ESPECIALIDADE */}

        {/* <h3 style={{ textAlign: "center", margin: "1rem 0" }}>
            Especialidades
          </h3> */}
        <FlexBox
          // direction="column"
          gap="1rem"
          style={{
            margin: "0 0 1rem 1rem",
            width: "auto",
            flexWrap: "wrap",
          }}
        >
          {/* <h3>Especialidades</h3> */}
          {/* <ChipsCardClean>
                <p style={{ whiteSpace: "nowrap", textAlign: "center" }}>
                  Por Especialidade
                </p>
              </ChipsCardClean> */}
          {hospitalData.especialidadeData.map(
            (item: any, idx: number) =>
              especialidadesColorMap[item.especialidade] && (
                <ChipsCardEspecialidade
                  key={idx}
                  // color={especialidadesColorMap[item.especialidade] + "80"}
                  color="#8791c380"
                  style={{
                    width: "calc(50% - 1rem)",
                  }}
                >
                  <h3
                    style={{
                      color: "white",
                      backgroundColor: "#8791c3",
                      // backgroundColor:
                      //   especialidadesColorMap[item.especialidade],
                      width: "fit-content",
                      padding: "6px 10px 4px",
                      borderTopLeftRadius: 8,
                      borderBottomRightRadius: 8,
                      // borderRadius: 10,
                      position: "relative",
                      top: "calc(-0.5rem - 1px)",
                      left: "calc(-1rem - 1px)",
                      fontWeight: "normal",
                    }}
                  >
                    {item.especialidade}
                  </h3>

                  <div
                    style={{
                      width: "100%",
                      position: "relative",
                      top: "-1.5rem",
                    }}
                  >
                    <PLineHeigth4 hospital={hospitalId}>agora</PLineHeigth4>
                    <FlexBox
                      justify="space-between"
                      style={{
                        backgroundColor: "#8791c320",
                        // backgroundColor:
                        //   especialidadesColorMap[item.especialidade] + "20",
                        // border:
                        //   "1px solid " +
                        //   especialidadesColorMap[item.especialidade] +
                        //   "80",
                        borderRadius: "10px",
                        padding: "0 1rem",
                      }}
                    >
                      <FlexBox
                        // gap="10px"
                        align="center"
                        justify="space-around"
                        style={{ marginRight: "1rem" }}
                      >
                        <p
                          style={{
                            whiteSpace: "nowrap",
                            fontSize: "16px",
                          }}
                        >
                          {strings.especialidade.aguardando_resumido}
                        </p>
                        <FlexBox gap="10px" align="center" width="fix-content">
                          <span
                            style={{ fontSize: "18px", fontWeight: "bold" }}
                          >
                            {item.pacientes_aguardando_atendimento}
                          </span>
                          <IoIosPeople
                            size="30px"
                            // color={especialidadesColorMap[item.especialidade]}
                            color="#8791c3"
                          />
                        </FlexBox>
                      </FlexBox>
                      <FlexBox
                        align="center"
                        gap="10px"
                        style={{
                          width: "unset",
                          // borderLeft:
                          //   "1px solid " +
                          //   especialidadesColorMap[item.especialidade] +
                          //   "80",
                          paddingLeft: "1rem",
                        }}
                      >
                        <ChipsCardClean>
                          <p>{strings.especialidade.classificacao_risco}</p>
                        </ChipsCardClean>

                        <FlexBox
                          width="auto"
                          justify="space-between"
                          gap="13.5px"
                        >
                          {riscoColorMap.map(({ color, risco, fontColor }) => (
                            <Tooltip
                              key={risco}
                              title={risco}
                              arrow
                              slotProps={slotProps(color, fontColor)}
                            >
                              <FlexBox
                                direction="column"
                                align="center"
                                justify="center"
                                width="auto"
                              >
                                <IoIosPeople size="25px" color={color} />
                                <ChipsCardClean>
                                  <span className="smallNum2">
                                    {risco === "vermelho"
                                      ? 0
                                      : item[
                                          `risco_${risco}` as keyof typeof item
                                        ]}
                                  </span>
                                </ChipsCardClean>
                              </FlexBox>
                            </Tooltip>
                          ))}
                        </FlexBox>
                      </FlexBox>
                    </FlexBox>
                  </div>

                  <FlexBox
                    // align="center"
                    // width="auto"
                    justify="space-between"
                    // style={{ marginTop: "5px" }}
                    gap="1rem"
                    style={{
                      position: "relative",
                      top: "-1rem",
                    }}
                  >
                    <BoxEspecialidade>
                      <PLineHeigth4 hospital={hospitalId}>
                        últimas 24h
                      </PLineHeigth4>
                      <div
                        style={{
                          backgroundColor: "#F5F5F5",
                          // border: "1px solid #A9A9A9",
                          borderRadius: "10px",
                          padding: "1rem 0.5rem 0.5rem",
                          // marginTop: "1.2rem",
                        }}
                      >
                        <FlexBox gap="1rem" justify="center">
                          <p
                            style={{
                              fontSize: "13px",
                              marginBottom: "5px",
                            }}
                          >
                            {strings.especialidade.tempoMedio}
                          </p>
                          {/* <FlexBox
                            gap="1rem"
                            style={{ justifyContent: "center" }}
                          >
                            <p>{strings.gaes}</p>
                            <p>
                              <b>{item.gae_abertas}</b>
                            </p>
                          </FlexBox>

                          <FlexBox
                            gap="1rem"
                            style={{ justifyContent: "center" }}
                          >
                            <p>{strings.desistentes}</p>
                            <p>
                              <b>{item.pacientes_desistentes}</b>
                            </p>
                          </FlexBox> */}
                        </FlexBox>

                        <FlexBox
                          width="auto"
                          justify="space-between"
                          // gap="30px"
                          // style={{ marginTop: 5 }}
                          style={{
                            marginTop: "0.5rem",
                          }}
                        >
                          {riscoColorMap.map(({ color, risco, fontColor }) => (
                            <Tooltip
                              key={risco}
                              title={risco}
                              arrow
                              slotProps={slotProps(color, fontColor)}
                            >
                              <FlexBox
                                direction="column"
                                align="center"
                                justify="center"
                                // gap="5px"
                                width="auto"
                              >
                                <IoIosPeople size="25px" color={color} />
                                <ChipsCardClean>
                                  <span className="smallNum3">
                                    {risco === "vermelho"
                                      ? "IMEDIATO"
                                      : hospital24h[
                                          Object.keys(hospital24h).find((k) =>
                                            normalize(k).includes(
                                              normalize(item.especialidade)
                                            )
                                          ) as keyof typeof hospital24h
                                        ]?.[0]?.[
                                          "tempo_atendimento_" + risco
                                        ] ?? "-"}
                                  </span>
                                </ChipsCardClean>
                              </FlexBox>
                            </Tooltip>
                          ))}
                        </FlexBox>
                      </div>
                    </BoxEspecialidade>

                    <BoxEspecialidade>
                      <PLineHeigth4 hospital={hospitalId}>
                        últimos 7 dias
                      </PLineHeigth4>

                      <div
                        style={{
                          backgroundColor: "#F5F5F5",
                          // border: "1px solid #A9A9A9",
                          borderRadius: "10px",
                          padding: "1rem 0.5rem 0.5rem",
                          // marginTop: "1.2rem",
                        }}
                      >
                        <div
                          style={{
                            fontSize: "13px",
                            marginBottom: "5px",
                            textAlign: "center",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-around",
                          }}
                        >
                          {strings.especialidade.tempoMedio}
                          {/* <p
                            style={{
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            Total:&nbsp;
                            <span>{item.tempoMedio7dias}&nbsp;</span>
                            <FaClock
                              size="20px"
                              // color={especialidadesColorMap[item.especialidade]}
                              color="8791c3"
                            />
                          </p> */}
                        </div>
                        {/* <FlexBox
                          justify="center"
                          // direction="column"
                          align="center"
                          gap="10px"
                        >
                          <p>Total</p>
                          <FlexBox align="center" gap="5px" width="fit-content">
                            <FaClock
                              size="20px"
                              // color={especialidadesColorMap[item.especialidade]}
                              color="#666"
                            />
                            <span>{item.tempoMedio7dias}</span>
                          </FlexBox>
                        </FlexBox> */}

                        <FlexBox
                          width="auto"
                          justify="space-between"
                          // gap="30px"
                          style={{ marginTop: "0.25rem" }}
                        >
                          {riscoColorMap.map(({ color, risco, fontColor }) => (
                            <Tooltip
                              key={risco}
                              title={risco}
                              arrow
                              slotProps={slotProps(color, fontColor)}
                            >
                              <FlexBox
                                direction="column"
                                align="center"
                                justify="center"
                                // gap="5px"
                                width="auto"
                              >
                                <IoIosPeople size="25px" color={color} />
                                <ChipsCardClean>
                                  <span className="smallNum3">
                                    {risco === "vermelho"
                                      ? "IMEDIATO"
                                      : hospital7d[
                                          Object.keys(hospital7d).find((k) =>
                                            normalize(k).includes(
                                              normalize(item.especialidade)
                                            )
                                          ) as keyof typeof hospital7d
                                        ]?.[0]?.[
                                          "tempo_atendimento_" + risco
                                        ] ?? "-"}
                                  </span>
                                </ChipsCardClean>
                              </FlexBox>
                            </Tooltip>
                          ))}
                        </FlexBox>
                      </div>
                    </BoxEspecialidade>
                  </FlexBox>
                </ChipsCardEspecialidade>
              )
          )}
        </FlexBox>
      </div>
    </BigCard>
  );
};

export default NewBigCardHospital;
